import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor"

export const getCorreos = async (IdListaCorreo) => {
   const result = await PrivateInterceptor(`Base/IT/ListaCorreo/${IdListaCorreo}`)
   return result
}